import { CombinedError } from "@urql/core";
import noop from "lodash/noop";
import { createContext, ReactNode, useContext, useEffect } from "react";
import { UseQueryExecute } from "urql";

import { useCurrentUser } from "../api/hooks/user/useCurrentUser.ts";
import { useTenantId } from "../hooks/useTenantId.ts";
import { CurrentUser } from "../types/user.ts";
import { isBababosSuperAdmin } from "../utils/user.ts";

interface ContextProps {
  user: CurrentUser | undefined | null;
  fetching: boolean;
  error: CombinedError | undefined | null;
  refresh: UseQueryExecute;
}

export const CurrentUserContext = createContext<ContextProps>({
  user: null,
  fetching: false,
  error: null,
  refresh: noop,
});

interface Props {
  children: ReactNode;
}

export const CurrentUserProvider = ({ children }: Props) => {
  const [currentUserData, refresh] = useCurrentUser();
  const user = currentUserData.data?.me;
  const { tenantId, setTenantId } = useTenantId();

  useEffect(() => {
    if (!tenantId && user?.tenantId && isBababosSuperAdmin(user)) {
      setTenantId(user.tenantId);
    }
  }, [setTenantId, tenantId, user]);

  return (
    <CurrentUserContext.Provider
      value={{
        user: currentUserData.data?.me,
        fetching: currentUserData.fetching,
        error: currentUserData.error,
        refresh,
      }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

export const useCurrentUserContext = () => useContext(CurrentUserContext);
